import { HttpContextToken, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingService } from "../services/loading/loading.service";
import { Observable, catchError, finalize, tap, throwError } from "rxjs";

export const SkipLoading = new HttpContextToken<boolean>(() => false);

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
    constructor(private loadingService: LoadingService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Verifica si la variable esta activa para saltar el loading
        if (req.context.get(SkipLoading)) {
            // Pasa directo sin loading
            return next.handle(req);
        }

        // carga el loading spinner
        this.loadingService.loadingOn();
        //console.log("req.url: "+req.url);
        
        return next.handle(req).pipe(
            catchError((error) => {
                // Manejo de errores
                this.loadingService.loadingOff();
                return throwError(() => error);
            }),
            finalize(() => {
                this.loadingService.loadingOff();
            })
        );
    }
}